import { createSlice } from "@reduxjs/toolkit";
import { addDays } from "date-fns";

const initialState = {
  dateRange: {
    startDate: addDays(new Date(), -1),
    endDate: addDays(new Date(), -1),
    key: "selection",
  },
  dataProduct: {
    id: 0,
    name: "",
  },
  kpiInitialData: {},
  metadataCompletenessData: {},
  dataCatalogCompletenessData: {},
  searchDataInfo: {},
  topQuestionsData: {},
  topSearchedDataProduct: {},
  dataProvenance: {},
  dataSharingAndCollaboration: {},
  mostUsedEntities: {},
  sampleDataDownloads: {},
  dailyAccessByProducts: {},
  dailyAccessByAssets: {},
};

const kpiDashboardSlice = createSlice({
  name: "kpiDashboard",
  initialState: initialState,
  reducers: {
    handleKPIDateRange(state, action) {
      state.dateRange = { ...action.payload };
    },
    handleKPIDataProduct(state, action) {
      state.dataProduct = action.payload;
    },
    updateKPIInitialData(state, action) {
      state.kpiInitialData = action.payload;
    },
    updateKPIMetadataCompletenessData(state, action) {
      state.metadataCompletenessData = action.payload;
    },
    updateKPIDataCatalogCompletenessData(state, action) {
      state.dataCatalogCompletenessData = action.payload;
    },
    updateKPISearchDataInfo(state, action) {
      state.searchDataInfo = action.payload;
    },
    updateKPITopQuestionsData(state, action) {
      state.topQuestionsData = action.payload;
    },
    updateKPITopSearchedDataProduct(state, action) {
      state.topSearchedDataProduct = action.payload;
    },
    handleKPIClearFilter(state, action) {
      state.dataProduct = {
        id: 0,
        name: "",
      };
      state.dateRange = {
        startDate: action.payload.startDate,
        endDate: action.payload.endDate,
        key: "selection",
      };
    },
    updateKPIDataProvenance(state, action) {
      state.dataProvenance = action.payload;
    },
    updateKPIDataSharingAndCollaboration(state, action) {
      state.dataSharingAndCollaboration = action.payload;
    },
    updateKPIDailyUsageAndConsumption(state, action) {
      state[action.payload?.key] = action.payload?.value;
    },
  },
});

export const {
  handleKPIDateRange,
  handleKPIDataProduct,
  updateKPIInitialData,
  updateKPIMetadataCompletenessData,
  updateKPIDataCatalogCompletenessData,
  updateKPISearchDataInfo,
  updateKPITopQuestionsData,
  updateKPITopSearchedDataProduct,
  handleKPIClearFilter,
  updateKPIDataProvenance,
  updateKPIDataSharingAndCollaboration,
  updateKPIMostUsedEntities,
  updateKPIDailyAccessByProducts,
  updateKPIDailyAccessByAsset,
  updateKPIDailyUsageAndConsumption,
} = kpiDashboardSlice.actions;
export default kpiDashboardSlice.reducer;
